import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardEmbedFigmaConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:embed-figma';

  override prepareBlock(figmaEmbed: BlockSnapshot): PreparedEdgelessBlock {
    return {
      create: () => {
        if (!this.surface) return null;
        const { xywh, style, url, caption, title, description } =
          figmaEmbed.props;

        const embedFigmaId = this.crud.addBlock(
          'affine:embed-figma',
          {
            xywh,
            style,
            url,
            caption,
            title,
            description,
          },
          this.surface.model.id
        );
        return embedFigmaId;
      },
    };
  }
}
